import React, { useState, useEffect } from 'react';
import exporticon from "../../../assets/image/Excel_Download_Icon.png";
import { getApi } from '../../../utils/services';
import { PETTY_CASH_LIST, STATUS_LIST } from '../../../utils/apiRoutes';
import { Link } from 'react-router-dom';
import moment from "moment";
import Loader from '../../common/Loader';
import { useTransactionContext } from '../../../utils/helpers/useTransaction';

const PettyCashBillReport = () => {
    const monthStartDate = moment().startOf('month');
    const monthEndDate = moment().endOf('month');

    const transactionList = useTransactionContext();
    const [fromDate, setFromDate] = useState(monthStartDate.format('YYYY-MM-DD'));
    const [toDate, setToDate] = useState(monthEndDate.format('YYYY-MM-DD'));
    const [statusList, setStatusList] = useState([]);
    const [statusId, setStatusId] = useState('');
    const [pettyCashReportList, setPettyCashReportList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [grandTotal, setGrandTotal] = useState(0);
    const [currencySymbol, setCurrencySymbol] = useState('');

    const handleStatusData = async () => {
        const result = await getApi(`${STATUS_LIST}?transactionId=${transactionList[5].id}`);
        setStatusList(result.res.status_list);
    };

    useEffect(() => {
        handleStatusData();
    }, []);

    useEffect(() => {
        const handlePettyCashReport = async () => {
            setLoader(true);
            const result = await getApi(`${PETTY_CASH_LIST}?startDate=${fromDate}&endDate=${toDate}&type='report'`);
            setLoader(false);
            setPettyCashReportList(result.res);

            const totalGrandAmount = result.res.pettyCash_list?.reduce((total, obj) => total + obj.Total, 0) || 0;
            setGrandTotal(totalGrandAmount);
            setCurrencySymbol(result.res.pettyCash_list?.[0]?.CurrencySymbol);
        };
        handlePettyCashReport();
    }, []);

    const handleExportData = () => {
        const csvData = [
            ['Bill Number', 'Bill Date', 'Created Date', 'Grand Total', 'Status', 'Allocated Funds'],
            ...pettyCashReportList.pettyCash_list?.map(item => [
                item.DocumentNo,
                moment(item.BillDate).format('D/MM/YYYY')?.slice(0, 10),
                moment(item.CreatedAt).format('D/MM/YYYY')?.slice(0, 10),
                item.Total,
                item.StatusName,
                item?.Funds?.length > 0
                    ? `"${item.Funds.map(fund => fund.FundNo).join(", ")}"`
                    : "N/A"
            ]) || [],

            [],
            ["", "", "Total:", grandTotal, "", ""]
        ];

        const csvContent = csvData.map(row => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'PettyCashBill.csv';
        link.click();
        URL.revokeObjectURL(url);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        const result = await getApi(`${PETTY_CASH_LIST}?startDate=${fromDate}&endDate=${toDate}&status=${statusId}&type='report'`);
        setLoader(false);
        setPettyCashReportList(result.res);

        const totalGrandAmount = result.res.pettyCash_list?.reduce((total, obj) => total + obj.Total, 0) || 0;
        setGrandTotal(totalGrandAmount);
        setCurrencySymbol(result.res.pettyCash_list?.[0]?.CurrencySymbol);
    };

    return (
        <form>
            <div className="form-style">
                <div className="report-inpfiled-container">
                    <div className="field-flex mb-20">
                        <label htmlFor="transactionStatus" className="form-label">
                            Transaction Status
                        </label>
                        <select
                            id="transactionStatus"
                            className="form-select"
                            name="transactionStatus"
                            value={statusId}
                            onChange={(e) => setStatusId(e.target.value)}
                        >
                            <option value="">Select</option>
                            {statusList.map((item, index) => (
                                <option key={index} value={item.id}>
                                    {item.Name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="field-flex mb-20">
                        <label htmlFor="fromDate" className="form-label">
                            From Date
                        </label>
                        <input
                            type="date"
                            id="fromDate"
                            className="form-control"
                            name="fromDate"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            onKeyDown={(e) => e.preventDefault()}
                        />
                    </div>

                    <div className="field-flex mb-20">
                        <label htmlFor="toDate" className="form-label">
                            To Date
                        </label>
                        <input
                            type="date"
                            id="toDate"
                            className="form-control"
                            name="toDate"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            onKeyDown={(e) => e.preventDefault()}
                        />
                    </div>

                    <div className="field-flex align-self-end mb-20">
                        <div className="success-btn">
                            <button type="submit" className="btn" onClick={handleSubmit}>
                                Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <hr className='m-0' />

            <Loader isLoading={loader} />
            <>
                {pettyCashReportList.record_count === 0 ? (
                    <div className="form-style">
                        <div className='section-sub-heading'>
                            <h3 className="text-center">{pettyCashReportList.message}</h3>
                        </div>
                    </div>
                ) : (
                    <div className="form-style pb-4">
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='section-sub-heading'>
                                <h3>Petty Cash</h3>
                            </div>
                            <div className='Export-Icon' onClick={handleExportData}>
                                <img src={exporticon} alt="" className='cursor-pointer' />
                            </div>
                        </div>
                        <div className='table-responsive tbl-body-shadow'>
                            <table className="w-100 table-theme-1">
                                <thead>
                                    <tr>
                                        <th className="text-right w-15 " >Bill Number</th>
                                        <th className="text-center w-15 ">Bill Date</th>
                                        <th className="text-center w-15" >Created Date</th>
                                        <th className="text-center w-15" >Grand Total</th>
                                        <th className="text-center w-15" >Status</th>
                                        <th className="text-end w-25">Allocated Funds</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pettyCashReportList.pettyCash_list?.map((row, index) => (
                                        <tr key={index}>
                                            <td className="text-right w-15">
                                                <Link className="" to={`/view-petty-cash/${row.id}`} target="_blank">
                                                    {row.DocumentNo}
                                                </Link>
                                            </td>
                                            <td className="text-center w-15">
                                                {moment(row.BillDate).format('D/MM/YYYY')?.slice(0, 10)}
                                            </td>
                                            <td className="text-center w-15">
                                                {moment(row?.CreatedAt).format('D/MM/YYYY')?.slice(0, 10)}
                                            </td>
                                            <td className="text-center w-15">
                                                {row?.CurrencySymbol} {row?.Total?.toFixed(2)}
                                            </td>
                                            <td className="text-center w-15">{row?.StatusName}</td>
                                            <td className="text-end w-25">
                                                {row?.Funds?.length > 0
                                                    ? row.Funds.map(fund => fund.FundNo).join(", ")
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr className="total-show">
                                        <td className="text-end text-dark table-footer fw-bold w-15"></td>
                                        <td className="text-end text-dark table-footer fw-bold w-15"></td>
                                        <td className="text-left text-dark text-center fw-bold w-15">Total</td>
                                        <td className="text-center text-dark fw-bold w-15" >
                                            {currencySymbol} {grandTotal?.toFixed(2)}
                                        </td>
                                        <td className="text-end text-dark fw-bold w-15"></td>
                                        <td className="text-end text-dark fw-bold w-25"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
            </>
        </form>
    );
};

export default PettyCashBillReport;

